import log from 'salvo-lite/log'

class Article {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._scrollTop = this._elem.querySelector('[data-scroll-top]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (this._scrollTop) {
            window.addEventListener('scroll', e => {
                if (window.scrollY > 800) {
                    this._scrollTop.classList.remove('visually-hidden')
                } else {
                    this._scrollTop.classList.add('visually-hidden')
                }
            })
            this._scrollTop.addEventListener('click', e => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            })
        }
    }
}

export default Article



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Article.js